import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Grid2 as Grid, Paper, Stack, Typography } from '@mui/material'
import { analytics } from 'utils/analytics'

function SignUpError() {
  const location = useLocation()
  const errorMessage = location.state?.message
  const errorCode = location.state?.code

  useEffect(() => {
    analytics.track('signup_error_page_viewed')
  }, [])

  return (
    <Grid
      container
      spacing={3}
      sx={{ minHeight: '100vh', paddingTop: { xs: '2vh', md: '5vh' }, px: { xs: 2, sm: 3, md: 0 } }}
    >
      <Grid size={{ xs: 0, md: 4 }}></Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Paper
          variant="outlined"
          elevation={0}
          sx={{ padding: 1, borderRadius: 2, mx: 'auto', p: { xs: 2, sm: 3 }, textAlign: 'center' }}
        >
          <Stack sx={{ mb: { xs: -0.5, sm: 0.5 } }} spacing={{ xs: 1.5, sm: 2 }}>
            <img
              src="/PurcentLogo.svg"
              alt="Purcent Logo"
              style={{ maxWidth: '160px', width: '100%', margin: '0 auto' }}
            />
            <Typography variant="h3" sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '1.25rem' } }}>
              Error creating account
            </Typography>
            <Typography>Please contact support for help</Typography>
            {errorMessage && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {errorMessage}
                {errorCode && ` (Code: ${errorCode})`}
              </Typography>
            )}
          </Stack>
        </Paper>
      </Grid>
      <Grid size={{ xs: 0, md: 4 }}></Grid>
    </Grid>
  )
}

export default SignUpError
